import { Shield } from '@phosphor-icons/react';

import { WizardStepHeader } from '../../wizard';
import pt from '../../../locales/pt';

export function DebtContextStep() {
  const copy = pt.liabilities.repaymentWizard.context;

  return (
    <div className="flex flex-col gap-3.5 pt-1.5">
      <WizardStepHeader
        eyebrow={copy.eyebrow}
        title={copy.title}
        subtitle={copy.lead}
      />

      <div className="flex flex-col gap-2.5">
        {copy.points.map((point, index) => (
          <div
            key={point}
            className="flex items-start gap-3 rounded-2xl border border-sage-200 bg-sage-50 px-[15px] py-3.5 dark:border-sage-800 dark:bg-sage-950/40"
          >
            <span className="inline-flex h-[30px] w-[30px] shrink-0 items-center justify-center rounded-full bg-card font-display text-sm font-bold text-sage-800 dark:text-sage-300">
              {index + 1}
            </span>
            <p className="m-0 text-[13.5px] leading-relaxed text-sage-800 dark:text-sage-200/90">
              {point}
            </p>
          </div>
        ))}
      </div>

      <div className="flex items-start gap-2.5 rounded-[14px] border border-border/80 bg-muted/40 px-3.5 py-3 dark:bg-muted/20">
        <Shield
          className="mt-0.5 h-[17px] w-[17px] shrink-0 text-sage-600 dark:text-sage-400"
          weight="regular"
          aria-hidden
        />
        <p className="m-0 text-[12.5px] leading-relaxed text-muted-foreground">
          {copy.helpNote}
        </p>
      </div>
    </div>
  );
}

export default DebtContextStep;
